import { StrictMode } from 'react';

import { createQueryClient, QueryProvider } from '@repo/core/query';
import { createRouter, RouterProvider } from '@tanstack/react-router';
import { OverlayProvider } from 'overlay-kit';
import { createRoot } from 'react-dom/client';

import { routeTree } from './routeTree.gen';
import './index.css';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Failed to find the root element');
}

const queryClient = createQueryClient();

const router = createRouter({
  routeTree,
  context: {
    queryClient,
  },
  defaultPreload: 'intent',
});
//main
createRoot(rootElement).render(
  <StrictMode>
    <OverlayProvider>
      <QueryProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryProvider>
    </OverlayProvider>
  </StrictMode>,
);
